/* ARTORINO — theme.js
   Carrito ajax, cuenta atrás, selector de variantes, galería. */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.ARTORINO || {};

  /* ---------- nav ---------- */
  var nav = $('#nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 20); };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- cuenta atrás ---------- */
  var target = null, cdEl = $('#countdown'), lblEl = $('#dropLabel');
  if (cdEl && lblEl) {
    if (CFG.dropStatus === 'closed') { lblEl.textContent = 'Window closed'; }
    else if (CFG.dropStatus === 'live') { lblEl.textContent = 'Closes in'; target = new Date(CFG.dropCloses); }
    else { lblEl.textContent = 'Opens in'; target = new Date(CFG.dropOpens); }

    var tick = function () {
      if (!target || isNaN(target)) { cdEl.innerHTML = ''; return; }
      var d = target - new Date();
      if (d <= 0) { cdEl.innerHTML = '<div class="cd-unit"><b>—</b><span>now</span></div>'; return; }
      var u = [['days', Math.floor(d / 864e5)], ['hours', Math.floor(d / 36e5) % 24],
               ['min', Math.floor(d / 6e4) % 60], ['sec', Math.floor(d / 1e3) % 60]];
      cdEl.innerHTML = u.map(function (x) {
        return '<div class="cd-unit"><b>' + String(x[1]).padStart(2, '0') + '</b><span>' + x[0] + '</span></div>';
      }).join('');
    };
    tick();
    setInterval(tick, 1000);
  }


  /* ---------- menú móvil ---------- */
  var mmenu = $('#mobileMenu'), burger = $('#burger'), burgerClose = $('#burgerClose');
  function openMenu() {
    if (!mmenu) return;
    mmenu.hidden = false;
    requestAnimationFrame(function () { mmenu.classList.add('open'); });
    if (burger) { burger.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mmenu || mmenu.hidden) return;
    mmenu.classList.remove('open');
    if (burger) { burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); }
    document.body.style.overflow = '';
    setTimeout(function () { mmenu.hidden = true; }, 300);
  }
  if (burger) burger.addEventListener('click', function () {
    mmenu.hidden ? openMenu() : closeMenu();
  });
  if (burgerClose) burgerClose.addEventListener('click', closeMenu);
  /* al tocar un enlace del mismo documento, cerrar para que se vea el destino */
  if (mmenu) $$('.mmenu-links a', mmenu).forEach(function (a) {
    a.addEventListener('click', function () { setTimeout(closeMenu, 60); });
  });
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  /* si se pasa a escritorio con el menú abierto, cerrarlo */
  addEventListener('resize', function () { if (innerWidth > 820) closeMenu(); });

  /* ---------- panel del carrito ---------- */
  var drawer = $('#cart'), scrim = $('#scrim');
  function openCart() {
    if (!drawer) return;
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('open'); scrim.classList.add('on'); });
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open'); scrim.classList.remove('on');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 320);
  }
  $$('#cartBtn, #cartBtnM, #cartBtnMenu').forEach(function (b) { b.addEventListener('click', function () { closeMenu(); openCart(); }); });
  var cartClose = $('#cartClose');
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (scrim) scrim.addEventListener('click', closeCart);
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeCart();
  });

  /* ---------- refrescar el carrito desde el servidor ---------- */
  function refreshCart() {
    return fetch('?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('#cartBody'), foot = doc.querySelector('#cartFoot');
        if (body) $('#cartBody').innerHTML = body.innerHTML;
        if (foot) $('#cartFoot').innerHTML = foot.innerHTML;
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('#cartCount, #cartCountM, #cartCountMenu').forEach(function (c) {
          c.textContent = cart.item_count;
          c.classList.toggle('has', cart.item_count > 0);
        });
        return cart;
      });
  }

  /* ---------- cantidades ---------- */
  var cartBody = $('#cartBody');
  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-act]');
      if (!b) return;
      var line = e.target.closest('.line');
      var key = line.getAttribute('data-key');
      var qty = parseInt(line.querySelector('.qty span').textContent, 10);
      var act = b.getAttribute('data-act');
      var next = act === 'inc' ? qty + 1 : act === 'dec' ? qty - 1 : 0;

      b.disabled = true;
      fetch(CFG.changeUrl || '/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { b.disabled = false; });
    });
  }

  /* ================= PÁGINA DE PRODUCTO ================= */
  var form = $('#addForm');
  if (form) {
    var select = $('#variantSelect');
    var addBtn = $('#addBtn');
    var errEl  = $('#addErr');
    var priceEl = $('#pdpPrice');

    function currentSelection() {
      return $$('.pills[data-option-index]').map(function (group) {
        var on = group.querySelector('.pill.on');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function syncVariant() {
      var sel = currentSelection().filter(Boolean).join(' / ');
      var match = null;
      $$('#variantSelect option').forEach(function (o) {
        if (o.getAttribute('data-options') === sel) match = o;
      });
      if (!match) return;
      select.value = match.value;
      if (priceEl) priceEl.textContent = match.getAttribute('data-price');
      var available = match.getAttribute('data-available') === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to bag' : 'Sold out';
      }
      if (errEl) errEl.textContent = '';
    }

    /* marcar agotadas dentro de cada grupo */
    function markUnavailable() {
      var groups = $$('.pills[data-option-index]');
      if (groups.length < 2) {
        /* con una sola opción, el valor mapea directo a la variante */
        groups.forEach(function (g) {
          $$('.pill', g).forEach(function (p) {
            var val = p.getAttribute('data-value'), out = true;
            $$('#variantSelect option').forEach(function (o) {
              if (o.getAttribute('data-options') === val && o.getAttribute('data-available') === 'true') out = false;
            });
            p.classList.toggle('out', out);
            p.disabled = out;
          });
        });
        return;
      }
      /* con varias opciones, marcamos el último grupo según los anteriores */
      var last = groups[groups.length - 1];
      var prefix = currentSelection().slice(0, groups.length - 1);
      $$('.pill', last).forEach(function (p) {
        var combo = prefix.concat([p.getAttribute('data-value')]).join(' / ');
        var out = true, low = false;
        $$('#variantSelect option').forEach(function (o) {
          if (o.getAttribute('data-options') === combo) {
            if (o.getAttribute('data-available') === 'true') out = false;
            var q = parseInt(o.getAttribute('data-qty'), 10);
            if (!isNaN(q) && q > 0 && q <= 3) low = true;
          }
        });
        p.classList.toggle('out', out);
        p.classList.toggle('low', low && !out);
        p.disabled = out;
      });
    }

    $$('.pills[data-option-index]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var p = e.target.closest('.pill');
        if (!p || p.disabled) return;
        $$('.pill', group).forEach(function (x) {
          x.classList.toggle('on', x === p);
          x.setAttribute('aria-checked', x === p ? 'true' : 'false');
        });
        markUnavailable();
        syncVariant();
      });
    });
    markUnavailable();
    syncVariant();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      errEl.textContent = '';
      var label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';

      fetch(CFG.addUrl || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: select.value, quantity: 1 }] })
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add.');
        return refreshCart().then(openCart);
      })
      .catch(function (err) { errEl.textContent = err.message; })
      .finally(function () { addBtn.disabled = false; addBtn.textContent = label; });
    });

    /* galería */
    $$('.pdp-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = $('#pdpImg');
        if (img) { img.removeAttribute('srcset'); img.src = b.getAttribute('data-full'); }
        $$('.pdp-thumbs button').forEach(function (x) { x.classList.toggle('on', x === b); });
      });
    });
  }

  /* ---------- página de contraseña ---------- */
  var pwEnter = $('#pwEnter'), pwModal = $('#pwModal'), pwCancel = $('#pwCancel');
  if (pwEnter && pwModal) {
    pwEnter.addEventListener('click', function () {
      pwModal.classList.add('on');
      var i = $('#pwInput'); if (i) i.focus();
    });
    if (pwCancel) pwCancel.addEventListener('click', function () { pwModal.classList.remove('on'); });
    pwModal.addEventListener('click', function (e) {
      if (e.target === pwModal) pwModal.classList.remove('on');
    });
    if (document.querySelector('.errors')) pwModal.classList.add('on');
  }
})();
